import React from "react";
import { Skeleton } from "../skeleton";

/**
 * Loading placeholder for OrganizationPage while it's on the (default) Organization
 * Details tab — shaped like the real page: breadcrumb + avatar/title/meta header, tab
 * bar, then OrganizationDetail's own two-card layout (Basic Information, Chat Settings).
 */
export const OrganizationDetailSkeleton: React.FC = () => {
    return (
        <div className="flex flex-col">
            {/* Breadcrumb */}
            <div className="flex items-center gap-2 px-6 pt-4">
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-4 w-3" />
                <Skeleton className="h-4 w-32" />
            </div>

            {/* Avatar + title + meta row */}
            <div className="flex items-center justify-between px-6 py-4">
                <div className="flex items-center gap-3">
                    <Skeleton className="h-14 w-14 shrink-0 rounded-full" />
                    <div>
                        <Skeleton className="mb-2 h-6 w-48" />
                        <div className="flex items-center gap-2">
                            <Skeleton className="h-3.5 w-20" />
                            <Skeleton className="h-3.5 w-3.5 rounded-full" />
                            <Skeleton className="h-3.5 w-16" />
                            <Skeleton className="h-3.5 w-3.5 rounded-full" />
                            <Skeleton className="h-3.5 w-28" />
                        </div>
                    </div>
                </div>
                <Skeleton className="h-8 w-32 rounded-md" />
            </div>

            {/* Tab bar */}
            <div className="border-border flex items-center gap-6 border-b px-6">
                {Array.from({ length: 5 }).map((_, i) => (
                    <Skeleton key={i} className="my-3 h-4 w-24" />
                ))}
            </div>

            {/* Organization Details tab content */}
            <div className="grid grid-cols-1 gap-4 p-6 lg:grid-cols-2">
                {Array.from({ length: 2 }).map((_, cardIndex) => (
                    <div key={cardIndex} className="border-border bg-card rounded-2xl border">
                        <div className="border-border flex items-center justify-between border-b p-4">
                            <div>
                                <Skeleton className="mb-2 h-4 w-36" />
                                <Skeleton className="h-3 w-56" />
                            </div>
                            <Skeleton className="h-7 w-7 shrink-0 rounded-md" />
                        </div>
                        <div className="flex flex-col gap-4 p-4">
                            {Array.from({ length: 3 }).map((_, fieldIndex) => (
                                <div key={fieldIndex}>
                                    <Skeleton className="mb-2 h-3.5 w-28" />
                                    <Skeleton className="h-9 w-full rounded-md" />
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
